// extracted by mini-css-extract-plugin
module.exports = {"image":"image___1SDko"};